import React from 'react';
import PropTypes from 'prop-types';

import '../../css/urlRenderer.css';

import { copyUrlToClipboard } from '../../util/url';

/* eslint-disable react/no-array-index-key */

const urlRenderer = ({ fragmentUrl }) => (
    <div className='url-renderer'>
        <div className='url-renderer__fragments'>
            {fragmentUrl.fragments.map((frag, index) => <span key={index} className='label' style={{ backgroundColor: frag.color }}>{frag.value}</span>)}
        </div>
        <button className='url-renderer__copy btn btn-link' onClick={() => copyUrlToClipboard(fragmentUrl.url)}>
            Copy to clipboard
        </button>
    </div>
);

urlRenderer.propTypes = {
    fragmentUrl: PropTypes.shape({
        value: PropTypes.string,
        fragments: PropTypes.arrayOf(PropTypes.shape({
            color: PropTypes.string,
            value: PropTypes.string,
        })),
    }),
};

export default urlRenderer;



// WEBPACK FOOTER //
// ./src/components/rendering/urlRenderer.jsx